import ClientLayout from "../../../components/client/layout/ClientLayout";
import ClientProjectTable from "../../../components/client/project/ClientProjectTable";
import ClientProjectRequestTable from "../../../components/client/project/ClientProjectRequestTable";

//클라이언트 프로젝트 메인 페이지
const ClientProjectMainPage: React.FC = () => {
    return (
        <ClientLayout>
            {/*클라이언트 프로젝트 테이블*/}
            <ClientProjectTable/>
            {/*클라이언트 프로젝트 요청 테이블*/}
            <ClientProjectRequestTable/>
        </ClientLayout>
    );
};
export default ClientProjectMainPage;
